import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import DataTable from 'react-data-table-component';
import Header_Supervisor from "../../Components/Header_Supervisor";
import { CSVLink } from 'react-csv';
import { paybridge_Url } from '../../Config';

const Supervisor_Report = () => {

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Filters
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('All');
  const [mobileNo, setMobileNo] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [companyId, setCompanyId] = useState('');

  // ✅ Get companyId from session
  useEffect(() => {
    const user = sessionStorage.getItem("user");

    if (user) {
      const userData = JSON.parse(user);
      setCompanyId(userData.companyId); // ✅ IMPORTANT
    } else {
      Swal.fire("Error", "User not logged in.", "errorr");
    }
  }, []);

  // ✅ Fetch Report (NEW API)
  const fetchReport = async () => {
    setLoading(true);

    try {
      const requestBody = {
        type: "custom" // optional (depends on API)
      };

      if (fromDate) requestBody.startDate = fromDate;
      if (toDate) requestBody.endDate = toDate;
      if (status !== "All") requestBody.status = status.toUpperCase();
      if (companyId) requestBody.companyId = companyId;
      if (mobileNo) requestBody.mobileNo = mobileNo;
      if (authCode) requestBody.authCode = authCode;

      const response = await axios.post(
        `${paybridge_Url}report/payments`,
        requestBody,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setReportData(response.data.data || []);
      } else {
        Swal.fire("Info", response.data.message || "No data found", "info");
        setReportData([]);
      }

    } catch (error) {
      Swal.fire("Error", "Failed to fetch report.", "error");
      setReportData([]);
    }

    setLoading(false);
  };

  // ✅ Table Columns (UPDATED like company)
  const columns = [
    { name: 'Transaction Ref', selector: row => row.txn_ref_no ?? '-', sortable: true },
    { name: 'Bill Ref', selector: row => row.bill_reference ?? '-', sortable: true },
    { name: 'Amount', selector: row => `PKR ${row.amount ?? '-'}`, sortable: true },
    { name: 'Mobile', selector: row => row.mobile_no ?? '-', sortable: true },
    { name: 'Status', selector: row => row.status ?? '-', sortable: true },
    { name: 'Customer', selector: row => row.CustomerName ?? '-', sortable: true },
    { name: 'Agent', selector: row => row.agent_Name ?? '-', sortable: true },
    { name: 'Company', selector: row => row.company_Name ?? '-', sortable: true },
    { name: 'Date', selector: row => row.created_at ? new Date(row.created_at).toLocaleString() : '-', sortable: true },
    { name: 'Auth Code', selector: row => row.pp_AuthCode ?? '-', sortable: true }
  ];

  // ✅ CSV Data
  const prepareCsvData = () => reportData.map(row => ({
    'Transaction Ref': row.txn_ref_no ?? '-',
    'Bill Reference': row.bill_reference ?? '-',
    'Amount': row.amount ?? '-',
    'Mobile No': row.mobile_no ?? '-',
    'Status': row.status ?? '-',
    'Customer Name': row.CustomerName ?? '-',
    'Agent Name': row.agent_Name ?? '-',
    'Company Name': row.company_Name ?? '-',
    'Created At': row.created_at ? new Date(row.created_at).toLocaleString() : '-',
    'Auth Code': row.pp_AuthCode ?? '-'
  }));

  return (
    <div className="container">
      <Header_Supervisor />

      <div className="card mt-3">
        <div className="card-header text-center">
          <h2>Supervisor Payments Report</h2>
        </div>

        <div className="card-body">

          {/* ✅ Filters Row */}
          <div className="row mb-3">

            <div className="col-md-2">
              <label>From Date</label>
              <input type="date" className="form-control"
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label>To Date</label>
              <input type="date" className="form-control"
                value={toDate}
                onChange={e => setToDate(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label>Status</label>
              <select className="form-control"
                value={status}
                onChange={e => setStatus(e.target.value)}
              >
                <option>All</option>
                <option>COMPLETED</option>
                <option>PENDING</option>
                <option>FAILED</option>
              </select>
            </div>

            <div className="col-md-2">
              <label>Mobile</label>
              <input type="text" className="form-control"
                value={mobileNo}
                onChange={e => setMobileNo(e.target.value)}
                placeholder="Optional"
              />
            </div>

            <div className="col-md-2">
              <label>Auth Code</label>
              <input type="text" className="form-control"
                value={authCode}
                onChange={e => setAuthCode(e.target.value)}
                placeholder="Optional"
              />
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={fetchReport}
                disabled={loading}
              >
                {loading ? "Loading..." : "Fetch Report"}
              </button>
            </div>

          </div>

          {/* ✅ Table */}
          {reportData.length > 0 && (
            <>
              <DataTable
                columns={columns}
                data={reportData}
                pagination
                highlightOnHover
                responsive
                striped
              />

              {/* ✅ CSV */}
              <div className="mt-3">
                <CSVLink
                  data={prepareCsvData()}
                  filename="supervisor_report.csv"
                  className="btn btn-success w-100"
                >
                  Download CSV
                </CSVLink>
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default Supervisor_Report;